export default __webpack_public_path__ + "static/media/sla.0e59a102.svg";